/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
	ClientApp,
	ClientAppVariant,
	ClientAppVariantTenantContract,
	ClientGeoAreaExtended,
	ClientTenant
} from '@DigitaleDoerfer/digitale-doerfer-api';

export type ValueOf<T> = T[keyof T];

export const FilterType = {
	APP_VARIANT: 'appVariant',
	TENANT: 'tenant'
} as const;

export type Filter<T> = T & {
	type: ValueOf<typeof FilterType>;
	isParentNode?: boolean;
};

export type App = ClientApp & { name: string; subItems?: AppVariant[] };

export type AppVariant = Omit<ClientAppVariant, 'app'> & {
	app: App;
	name: string;
};

export type Tenant = ClientTenant & {
	name: string;
};
export type Contract = ClientAppVariantTenantContract & {
	name: string;
};

export const ListType = {
	...FilterType,
	CONTRACT: 'contract'
} as const;

export type SearchQuery = {
	query: string;
	type: ValueOf<typeof ListType>;
};

export type TreeNodeItem<T> = T & { type: ValueOf<typeof ListType> };

export type Filters = { [key in ValueOf<typeof FilterType>]: { [key: string]: Filter<AppVariant | Tenant> } };

export type GeoArea = ClientGeoAreaExtended;
